import React, { useState, useEffect } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import usexAPI from "store/customHooks/usexAPI";
import classnames from "classnames";
import Notice_list from "components/csboard/Notice_list";
import Faq_list from "components/csboard/Faq_list";
import Inform_list from "components/csboard/Inform_list";
import { xAPI_IA } from "utils/xAPI_IA";
import { ANOUN_LIST_REQUEST, GO_ANOUN_LIST, SET_PAGE_RELOAD, ANOUN_DETAILED_REQUEST } from "containers/csboard/Action";
import { useSelector, useDispatch } from "react-redux";
import Notice_detail from "components/csboard/Notice_detail";

const CUS_IA = {
    anounList: "CUS_Notice",
    faqList: "CUS_Faq",
    termsInfo: "CUS_Terms",
};

const Cspage = (props) => {
    const dispatch = useDispatch();
    const { Screen } = usexAPI();
    const { myInfo, mode, type, setType, paramSeq } = props;

    const anounImptList = useSelector((state) => state.csboardReducer.anounImptList);
    const anounNimptList = useSelector((state) => state.csboardReducer.anounNimptList);
    const anounDetailed = useSelector((state) => state.csboardReducer.anounDetailed);
    const renderState = useSelector((state) => state.csboardReducer.renderState);
    const reloadState = useSelector((state) => state.csboardReducer.reloadState);

    const [btn, setBtn] = useState(1);
    const [activeTab, setActiveTab] = useState(type);

    const toggle = (tab) => {
        setBtn(btn + 1);
        if (activeTab !== tab) setActiveTab(tab);
        setType(activeTab);
    };

    useEffect(() => {
        if (btn > 1) {
            switch (activeTab) {
                case "anounList":
                    dispatch(
                        SET_PAGE_RELOAD({
                            reloadState: "1",
                        }),
                    );
                    break;
                case "faqList":
                    dispatch(
                        SET_PAGE_RELOAD({
                            reloadState: "2",
                        }),
                    );
                    break;
                case "termsInfo":
                    dispatch(
                        SET_PAGE_RELOAD({
                            reloadState: "3",
                        }),
                    );
                    break;
                case "mtrlList":
                    dispatch(
                        SET_PAGE_RELOAD({
                            reloadState: "4",
                        }),
                    );
                    break;
            }
        }
    }, [btn]);

    useEffect(() => {
        if (renderState === "1") {
            dispatch(
                ANOUN_LIST_REQUEST({
                    headerParam: myInfo.userId,
                    searchType: "",
                    keyword: "",
                    from: 0,
                    size: 10,
                }),
            );
        }
    }, [renderState]);

    useEffect(() => {
        dispatch(GO_ANOUN_LIST());
    }, []);

    useEffect(() => {
        const IAContent = xAPI_IA[CUS_IA[activeTab]].IA;
        Screen().setContent({ IAContent }).opened();
    }, [activeTab]);

    const render = {
        noticeList: (
            <Notice_list
                user_id={myInfo.userId}
                anounImptList={anounImptList}
                anounNimptList={anounNimptList}
                mode={mode}
                reloadState={reloadState}
            />
        ),
        noticeDetail: (
            <Notice_detail
                user_id={myInfo.userId}
                mode={mode}
                anounDetailed={anounDetailed.ANOUN_DETAILED}
                file={anounDetailed.FILE}
            />
        ),
    };

    let currentValue;

    // state = 2거나 paramSeq가 있는 경우
    if (renderState === "1") {
        setType("anounList");
        currentValue = "noticeList";
    } else if (renderState === "2" || paramSeq) {
        currentValue = "noticeDetail";
    } else {
        setType("anounList");
        currentValue = "noticeList";
    }

    useEffect(() => {
        if (props.paramSeq) {
            dispatch(
                ANOUN_DETAILED_REQUEST({
                    headerParam: myInfo.userId,
                    anounSeq: props.paramSeq,
                }),
            );
        }
    }, [props.paramSeq]);

    return (
        <>
            <div className="cs_tab_wrap overflow-hidden">
                <div className="cs_tabs">
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === "anounList" })}
                                onClick={() => {
                                    toggle("anounList");
                                }}
                            >
                                공지사항
                            </NavLink>
                        </NavItem>
                        {/* <NavItem>
							<NavLink
								className={classnames({ active: activeTab === "mtrlList" })}
								onClick={() => {
									toggle("mtrlList");
								}}
							>
								학습 자료실
							</NavLink>
						</NavItem> */}
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === "faqList" })}
                                onClick={() => {
                                    toggle("faqList");
                                }}
                            >
                                자주 묻는 질문
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === "termsInfo" })}
                                onClick={() => {
                                    toggle("termsInfo");
                                }}
                            >
                                약관보기
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="anounList">{render[currentValue]}</TabPane>
                    <TabPane tabId="faqList" className="tab_2">
                        <Faq_list user_id={myInfo.userId} mode={mode} reloadState={reloadState} />
                    </TabPane>
                    <TabPane tabId="termsInfo" className="tab_3">
                        <Inform_list
                            userId={myInfo.userId}
                            userSeq={myInfo.userSeq}
                            mode={mode}
                            reloadState={reloadState}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </>
    );
};

export default Cspage;
